import { createAction } from "redux-actions";
import { GET_AGREEMENTS } from "../constants";
import { feathersFindGET } from "../services";

export const getAgreements = createAction(GET_AGREEMENTS, () => feathersFindGET('agreements',{$limit: 100})())